import * as Yup from "yup";
import "yup-phone";
import { USERTYPES } from "../constants/Constants";
import { ENABLE_WHATSAPP } from "../config/appFlags";


const EmailYup = Yup.string()
  .trim()
  .max(255, "Email must be at most 255 characters.")
  .email("Email is not valid.")
  .required("Email cannot be blank.")
  .when("checkSecurityFlag", {
    is: true,
    then: (schema) =>
      schema.test(
        "no-plus",
        "Email cannot contain '+' tags.",
        (val) => {
          if (!val) return true;
          const [local] = val.split("@");
          return !local.includes("+");
        }
      ),
    otherwise: (schema) => schema // allow '+' when flag is false
  });


  
export const AdminSchema = Yup.object({
  firstName: Yup.string().min(3,"First Name must be at least 3 characters.").max(50, 'First Name must be at most 50 characters.').matches(/^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/,"First Name is invalid.").required("First Name cannot be blank."),
  lastName: Yup.string().min(3, "Last Name must be at least 3 characters.").max(50, 'Last Name must be at most 50 characters.').matches(/^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/,"Last Name is invalid.").required("Last Name cannot be blank."),
  // email: Yup.string().email("Email is not valid.").max(255).required("Email cannot be blank."),
  email: EmailYup,
  //mobile: Yup.string().phone().required("Mobile Number cannot be blank"),
  username: Yup.string()
              .min(3 ,"Username must be at least 3 characters.")
              .max(255, "Username must be at most 255 characters.")
              .matches(
                /^[0-9a-zA-Z]+([0-9a-zA-Z]*[-._+])*[0-9a-zA-Z]+(@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,6})?$/,
                "Username is invalid."
              ).required("Username cannot be blank."),
  password: Yup.string()
              .min(8, "Password must be at least 8 characters.")
              .max(100, "Password must be at most 100 characters.")
              .matches(/^[\S]*$/, "Password cannot contain spaces.")
              .required("Password cannot be blank."),
  confirmPassword: Yup.string().required("Confirm Password cannot be blank.").when("password", {
    is: (val) => (val && val.length > 0 ? true : false),
    then: Yup.string().oneOf(
      [Yup.ref("password")],
      "Password doesn't match."
    ),
  }),
  signatureText: Yup.string()
    .max(100, "Signature Text must be at most 100 characters.").nullable(),
  capacity: Yup.number()
    .when("role", {
      is: (role) => role === USERTYPES.SUPERVISOR,
      then: Yup.number()
        .min(0, "Capacity cannot be less than 0!")
        .max(999, "Capacity should be less than 1000!"),
      otherwise: Yup.number()
        .min(1, "Capacity should be greater than 0!")
        .max(999, "Capacity should be less than 1000!"),
    })
    .required("Capacity cannot be blank."),

  technicianContactList: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .min(3, "Name must be at least 3 characters.")
          .max(50, "Name must be at most 50 characters.")
          .required("Name cannot be blank.")
      })
    ),
  //  // whatsapp number conditional — add this
  // whatsappNumber: Yup.string().nullable().when("enableWhatsApp", {
  //   is: true,
  //   then: Yup.string()
  //   .required(""),
    
  //   otherwise: Yup.string().nullable()
  // }),
  whatsappNumber: Yup.string()
  .nullable()
  .when("enableWhatsApp", {
    is: true,
    then: Yup.string()
      .test(
        "valid-whatsapp-number",
        "",
        (value) => {
          if (!value) return false;

          // Remove "+"
          const digits = value.replace("+", "");

          // country code only (e.g. "91") is INVALID
          // require at least 7 digits total (safe for all countries)
          return digits.length > 6;
        }
      ),
    otherwise: Yup.string().nullable()
  }),
    // optional: explicitly declare the two booleans so schema is clear
  enableEmail: Yup.boolean().default(false),
  enableWhatsApp: Yup.boolean().default(false),
  specialist: Yup.string()
    .max(20, "Specialization must be at most 20 characters.")
    .nullable(),
})
.test(
  "contact-required",
  "Choose either Email or WhatsApp (or both).",
  function (value) {
    // value is the whole form object because this is a schema-level test
    const form = value || {};
    const enableEmail = !!form.enableEmail;
    const enableWhatsApp = ENABLE_WHATSAPP && !!form.enableWhatsApp;

    if (!ENABLE_WHATSAPP) {
      if (enableEmail) return true;
      return this.createError({
        path: "enableEmail",
        message: "Email is required.",
      });
    }

    if (enableEmail || enableWhatsApp) {
      return true;
    }

    // Determine which channel was the only option using parent flags stored in form
    const onlyWhatsApp = !!form.whatsappParentEnabled && !form.emailParentEnabled;
    const onlyEmail = !!form.emailParentEnabled && !form.whatsappParentEnabled;

    if (onlyWhatsApp) {
      return this.createError({
        path: "enableEmail",
        message: "Mobile cannot be blank.",
      });
    }
    if (onlyEmail) {
      return this.createError({
        path: "enableEmail",
        message: "Email cannot be blank.",
      });
    }

    return this.createError({
      path: "enableEmail",
      message: "Choose either Email or WhatsApp (or both).",
    });
  }
);


export const ProfileSchema = Yup.object({
  firstName: Yup.string().min(3,"First Name must be at least 3 characters.").max(50, 'First Name must be at most 50 characters.').matches(/^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/,"First Name is invalid.").required("First Name cannot be blank."),
  lastName: Yup.string().min(3, "Last Name must be at least 3 characters.").max(50, 'Last Name must be at most 50 characters.').matches(/^[a-zA-Z]+(?:\s+[a-zA-Z]+)*$/,"Last Name is invalid.").required("Last Name cannot be blank."),
  email: Yup.string().email("Email is not valid.").max(255).required("Email cannot be blank."),
  //mobile: Yup.string().phone().required("Mobile Number cannot be blank"),
  username: Yup.string()
              .min(3 ,"Username must be at least 3 characters.")
              .max(255, "Username must be at most 255 characters.")
              .matches(
                /^[0-9a-zA-Z]+([0-9a-zA-Z]*[-._+])*[0-9a-zA-Z]+(@[0-9a-zA-Z]+([-.][0-9a-zA-Z]+)*([0-9a-zA-Z]*[.])[a-zA-Z]{2,6})?$/,
                "Username is invalid."
              ).required("Username cannot be blank."),
  password: Yup.string()
              .min(8, "Password must be at least 8 characters.")
              .max(100, "Password must be at most 100 characters.")
              .matches(/^[\S]*$/, "Password cannot contain spaces.")
              .required("Password cannot be blank."),
  confirmPassword: Yup.string().required("Confirm Password cannot be blank.").when("password", {
    is: (val) => (val && val.length > 0 ? true : false),
    then: Yup.string().oneOf(
      [Yup.ref("password")],
      "Password doesn't match."
    ),
  }),
  signatureText: Yup.string()
    .max(100, "Signature Text must be at most 100 characters.").nullable(),
  specialist: Yup.string()
    .max(20, "Specialization must be at most 20 characters.")
    .nullable(),
  technicianContactList: Yup.array().of(
      Yup.object().shape({
        name: Yup.string()
          .min(3, "Name must be at least 3 characters.")
          .max(50, "Name must be at most 50 characters.")
          .required("Name cannot be blank.")
      })
    ),
    // --- Notification fields (conditional) ---
  enableEmail: Yup.boolean().default(false),
  enableWhatsApp: Yup.boolean().default(false),

// user-level toggles (whether user chose that channel)
  useEmail: Yup.boolean().default(false),
  useWhatsApp: Yup.boolean().default(false),

  // whatsapp number required only if master gate AND user toggle are both true
  whatsappNumber: Yup.string()
    .nullable()
    .when(["enableWhatsApp", "useWhatsApp"], {
      is: (enableWhatsApp, useWhatsApp) => enableWhatsApp === true && useWhatsApp === true,
      then: Yup.string()
        .required("")
        .matches(/^\+?\d{7,15}$/, "WhatsApp Number is invalid."),
      otherwise: Yup.string().nullable(),
    }),

  // ... other fields (capacity, signature, etc.) can follow here ...
})
// Schema-level test: require at least one of the channels enabled
.test(
  "contact-required",
  "Choose either Email or WhatsApp (or both).",
  function (value) {
    const form = value || {};
    const enableEmail = !!form.enableEmail;
    const enableWhatsApp = !!form.enableWhatsApp;
    const useEmail = !!form.useEmail;
    const useWhatsApp = !!form.useWhatsApp;

    console.log(
      "[ASssssssssss YUP contact-required] value:", value,
      "enableEmail:", enableEmail,
      "enableWhatsApp:", enableWhatsApp,
      "useEmail:", useEmail,
      "useWhatsApp:", useWhatsApp,
      "this.path:", this.path
    );

    if (useEmail || useWhatsApp) {
      return true;
    }

    if (enableEmail && !enableWhatsApp) {
      return this.createError({
        path: "useEmail",
        message: "Email cannot be empty.",
      });
    }

    if (enableWhatsApp && !enableEmail) {
      return this.createError({
        path: "useEmail",
        message: "WhatsApp cannot be empty.",
      });
    }

    if (enableEmail && enableWhatsApp && !useEmail && !useWhatsApp) {
      return this.createError({
        path: "useEmail",
        message: "Choose either Email or WhatsApp (or both).",
      });
    }

    return this.createError({
      path: "useEmail",
      message: "Email field and WhatsApp field can't be empty.",
    });

});

